import { updateAddressMockHandler } from '@/features/profiles/api/update-address';
import { updateProfileMockHandler } from '@/features/profiles/api/update-profile';

export const profilesHandlers = [
  updateProfileMockHandler,
  updateAddressMockHandler,
];
